import { render, staticRenderFns } from "./knowledges.vue?vue&type=template&id=aaa43c54&scoped=true&lang=pug&"
import script from "./knowledges.vue?vue&type=script&lang=coffee&"
export * from "./knowledges.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa43c54",
  null
  
)

export default component.exports